// redux/slices/pageSlice.js
import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  isLoading: false,
  error: null,
  pageData: null,
  dynamicContent: {},
};

const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setPageData(state, action) {
      state.isLoading = false;
      state.pageData = action.payload;
    },
    setDynamicContent(state, action) {
      state.dynamicContent = action.payload;
    },
  },
});

export const { startLoading, hasError, setPageData, setDynamicContent } = pageSlice.actions;

export default pageSlice.reducer;

export const fetchRenderPage = (id) => async (dispatch) => {
  try {
    dispatch(startLoading());

    const response = await axios.get(`/builder/get-template/${id}`);
    const { page } = response.data;

    const placeholderMatches = page.html.match(/data-type="(.*?)"/g) || [];
    const placeholders = placeholderMatches.map((match) =>
      match.match(/data-type="(.*?)"/)[1]
    ); 

    const contentPromises = placeholders.map((type) =>
      axios.get(`/builder/dynamic-content`, { params: { type } })
    );

    const contentResults = await Promise.all(contentPromises);

    const contentMap = placeholders.reduce((acc, type, index) => {
      acc[type] = contentResults[index].data;
      return acc;
    }, {});

    dispatch(setPageData(page));
    dispatch(setDynamicContent(contentMap));
  } catch (error) {
    dispatch(hasError(error.message || "Failed to load page"));
  }
};
